import { StripedTableRow as StyledTableRow } from '@edge/spark/ui-mui'
import { Paper, TableBody, TableCell, TableHead, TableRow } from '@mui/material'
import { StyledTable } from './VehicleHelpTab'

const rows = [
    { name: 'Sale Date Offset', prefix: 'saledate:', example: 'saledate:10' },
    { name: 'Check-In Offset', prefix: 'checkindate:', example: 'checkindate:3' },
    { name: 'Lane', prefix: 'lane:', example: 'lane:1x' },
    { name: 'Run #', prefix: 'run:', example: 'run:1x-30' },
    {
        name: 'Status',
        prefix: 'status:',
        example: 'status:sold, status:inventory, status:arbitration, status:consigned, or status:in-sale,',
    },
]

const SaleHelpTab = () => {
    return (
        <Paper sx={{ width: '100%', mt: 2, overflowX: 'auto', minHeight: 428 }}>
            <StyledTable aria-label="customized table">
                <TableHead>
                    <TableRow>
                        <TableCell align="left">Search</TableCell>
                        <TableCell align="center">Prefix</TableCell>
                        <TableCell align="center">Example</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {rows.map((row) => (
                        <StyledTableRow key={row.name}>
                            <TableCell align="left">{row.name}</TableCell>
                            <TableCell align="center">{row.prefix}</TableCell>
                            <TableCell sx={{ maxWidth: 130 }} align="center">
                                {row.example}
                            </TableCell>
                        </StyledTableRow>
                    ))}
                </TableBody>
            </StyledTable>
            {/* <Typography className={} variant="caption">
        (status options inlcude: Inventory, Sold, Consigned, Arbitration, or
        In-Sale)
      </Typography> */}
        </Paper>
    )
}

export default SaleHelpTab
